import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import { GET_CUSTOMER_TICKETS } from '../../graphql/queries';
import { formatMoney, formatMonthDayYear } from '../../../../utils/utils';
import QueryGuard from '../../../../Components/QueryGuard';
import Table from '../../../../Components/Table';
import { Ticket } from '../../../Tickets/types';
import { useNavigate } from 'react-router-dom';

interface Props {
  customerId: string;
}

const CustomerTickets: FC<Props> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, error, loading } = useQuery(GET_CUSTOMER_TICKETS, { variables: { customerId } });

  const renderTicketTable = (tickets: Ticket[]) => {
    const tableData = tickets.map((ticket) => ({
      data: {
        company: ticket.company ? ticket.company : '-',
        date: formatMonthDayYear(+ticket.date),
        total: ticket.customerPayment ? formatMoney(ticket.customerPayment.total.amount || 0) : '-',
        partner: ticket.partner || '-'
      },
      onRowClick: () => navigate(`/tickets/${ticket.id}`)
    }));

    return <Table tableData={tableData} />;
  };

  return (
    <QueryGuard data={data && data.tickets} loading={loading} error={error ? !!error : false} displayNoResult={false}>
      {data && data.tickets && (
        <div>
          <h2 className="text-lg font-bold my-4">Tickets</h2>
          <div>{renderTicketTable(data.tickets)}</div>
        </div>
      )}
    </QueryGuard>
  );
};

export default CustomerTickets;
